import React, { useState } from 'react';
import { Button, Form, Input, Modal } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import "./StartModal.css"
import axios from 'axios'



const StartModal = (props) => {
  const [errMsg, setErrMsg] = useState("")


  const verifyKey = () => {

    const client = axios.create({
      headers: { 'Authorization': 'Bearer ' + props.apiKey }
    });

    const params = {
      "model": "gpt-3.5-turbo",
      "messages": [{ "role": "user", "content": "Test" }],
      "temperature": 0.7
    }

    client.post('https://api.openai.com/v1/chat/completions', params)
      .then(() => {
        props.setValidKey(true);
      }).catch(err => {
        if (err.response.status === 401) {
          setErrMsg("Clé API non autorisée")
        } else {
          setErrMsg("Erreur, veuillez réessayer")
        }
      })
  }

  return (

    <Modal open={!props.validKey} size="tiny">
      <Modal.Header><h1>Giustizia per Telefono</h1></Modal.Header>
      <Modal.Content>
        <div className="description">Bienvenue dans Giustizia per Telefono ! Pour jouer à ce jeu d'enquête, vous devez renseigner une clé API GPT valable. Le coût dépendra de votre quantité de messages, mais se compte généralement sur quelques dizaines de centimes pour une partie.</div>
        <Form className="form">
          <Form.Field>
            <label>Clé API</label>
            <Input
              placeholder="Entrez votre clé API de GPT"
              value={props.apiKey}
              onChange={(e) => props.setApiKey(e.target.value)}
            />
          </Form.Field>
        </Form>
        <div className="err-msg">{errMsg}</div>
        <Modal.Actions>
          <Button positive onClick={verifyKey}>
            Commencer le jeu
          </Button>
        </Modal.Actions>
      </Modal.Content>
    </Modal>
  );
};

export default StartModal;